module.exports = __webpack_public_path__ + "img/favorite.4219b905.svg";